import type { DrawingContext } from '@studio/design-system/canvas';
import type { Coordinate } from '@studio/js-utils/geometry';
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { GridLines } from '#~/control/index.js';

/** Fast frame drawing context. */
export type FastFrameDrawingContext = DrawingContext & {
  fastFrameSelectPosition: Coordinate;
  gridLines: GridLines;
  scale: number;
  stage: FastFrameSelectStage;
};

/** Draw the cursor. */
export interface MouseEntryContext {
  /** Initial scale upon mouse entry. */
  scale: number;
}

/** Fast frame select stage. */
export type Wiring = Readonly<{
  /** Handle drag event. */
  handleDrag: (event: React.MouseEvent) => void;

  /** Handle drag end event. */
  handleDragEnd: (event: React.MouseEvent) => void;

  /** Handle drag start event. */
  handleDragStart: (event: React.MouseEvent) => void;

  /** Handle draw cursor. */
  handleDrawCursor: (context: DrawingContext, position?: Coordinate) => void;

  /** Handle mouse entry. */
  handlePointerLeave: () => void;

  /** Handle mouse entry. */
  handleWheelEvent: (event: React.WheelEvent) => void;

  /** The initial position of the cursor. */
  initialPosition: T_Maybe<Coordinate>;

  /** Should use cine. */
  useCine: boolean;
}>;

/** Fast frame wiring. */
export enum FastFrameSelectStage {
  CONFIRM = 'confirm',
  INITIAL = 'initial'
}
